<template>
  <div
    class="preselect__container"
    :class="[
      `preselect__container--${colorSchema}`,
      { 'preselect__container--wide': showFullWidth },
    ]"
  >
    <div v-if="title" class="heading-h3 heading-thick">{{ title }}</div>
    <div class="preselect__attributes">
      <div
        v-for="field in fields"
        :key="field.name"
        class="preselect__row preselect-boolean__row"
        :class="`preselect__row--${fields.length}-rows`"
      >
        <div>
          <input
            :id="fieldId(field.name)"
            type="checkbox"
            class="form__input form__input--checkbox"
            :name="field.name"
            :value="field.checkboxValue ?? '1'"
            :checked="selected[field.name] ?? false"
            @change="onCheckboxChange(field.name, $event)"
          />
          <label :for="fieldId(field.name)" class="preselect__label preselect-boolean__label">
            {{ field.label }}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, reactive } from 'vue';

import type { CategoryPreselectBooleanBlockProps } from './CategoryPreselectBooleanBlock.types';

const props = defineProps<CategoryPreselectBooleanBlockProps>();

const toBool = (value: boolean | string | undefined): boolean => value === true || value === 'true';

const selected = reactive<Record<string, boolean>>({});

const fieldId = (name: string): string => `category-preselect-boolean-${name}`;

const applyFacet = (key: string, value: string, checked: boolean): void => {
  if (toBool(props.emitEvent)) {
    const url = new URL(window.location.href);
    if (checked && value) {
      url.searchParams.set(key, value);
    } else {
      url.searchParams.delete(key);
    }
    window.location.href = url.toString();
    return;
  }

  const baseUrl = props.categoryUri;
  if (!baseUrl) {
    return;
  }

  if (checked && value) {
    window.location.href = `${baseUrl}?${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    return;
  }

  window.location.href = baseUrl;
};

const onCheckboxChange = (name: string, event: Event): void => {
  const target = event.target as HTMLInputElement;
  selected[name] = target.checked;
  applyFacet(name, target.value, target.checked);
};

onMounted(() => {
  const url = new URL(window.location.href);
  props.fields.forEach(field => {
    const value = url.searchParams.get(field.name);
    selected[field.name] = value === (field.checkboxValue ?? '1');
  });
});
</script>
